import { render, staticRenderFns } from "./UploadLeads.vue?vue&type=template&id=5bf9c87f&"
import script from "./UploadLeads.vue?vue&type=script&lang=js&"
export * from "./UploadLeads.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports